import { render, staticRenderFns } from "./DkPartnerPromoLabel.vue?vue&type=template&id=83a04bde&"
import script from "./DkPartnerPromoLabel.vue?vue&type=script&lang=js&"
export * from "./DkPartnerPromoLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports